import React, { useState, useEffect, createRef } from "react";
import Background_unit from "../../images/unit/Background_unit.png";
import Background_unit_ride from "../../images/unit/Background_unit_ride.png";
import chat from "../../images/unit/chat.svg";
import styled from "styled-components/macro";
import { UnitData } from "./UnitData";
import { UnitTool } from "./UnitTools";
import { useScreenshot } from "use-react-screenshot";
import { getColumns } from "./unit_items_logic";
import { useSelector } from "react-redux";
import { UnitStepButtons } from "./unit_step_buttons";
import { RoomUnit } from "./room_unit";
import { RideUnit } from "./ride_unit";

export const unitBoxSizes = {
  small: 75,
  medium: 158,
  large: 324,
  xl: 490,
};

const unitStepDic = {
  unit: 0,
  ride: 1,
};

const CreateUnitPage = ({
  onQuoteClick,
  collectDate,
  columns,
  setColumns,
  rideItems,
  setRideItems,
}) => {
  const { items } = useSelector(mapStateToProps);
  const [itemsCount, setItemsCount] = useState({});
  const [unitDirection, setUnitDirection] = useState({
    unit: { x: 0, y: 0 },
    ride: { x: 0, y: 0 },
  });
  const [unitScale, setUnitScale] = useState({ unit: 1, ride: 1 });
  const [background, setBackground] = useState();
  const [backgroundRide, setBackgroundRide] = useState();
  const [unitStep, setUnitStep] = useState(unitStepDic.unit);
  const [logoImage, setLogoImage] = useState();
  const [showDimensions, setShowDimensions] = useState(false);
  const [colorUnit, setColorUnit] = useState("#f9f3e9");
  const unitWrapperRef = createRef();
  const [, takeScreenshot] = useScreenshot();
  const getImage = () => takeScreenshot(unitWrapperRef.current);

  useEffect(() => {
    let newColumns;
    let ride;

    if (!columns) {
      const { columns: columnsRes, ride: rideRes } = getColumns(
        collectDate,
        items
      );
      newColumns = columnsRes;
      ride = rideRes;
      setColumns(newColumns);
      setRideItems(ride);
    } else {
      newColumns = columns;
      ride = rideItems;
    }

    const newItems = {};

    [Object.values(ride), ...newColumns].map((e) =>
      e.map(
        (i) =>
          (newItems[i.id] = {
            count: (newItems[i.id]?.count || 0) + (i.countInUnit || 1),
            item: i,
          })
      )
    );
    delete newItems.undefined;

    console.log({ newItems });

    setItemsCount(newItems);
    // Mount-once: initializes columns/rideItems/itemsCount a single time.
    // Tracking columns/items/etc. would re-run the one-time init on every
    // data change and clobber later state, changing behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper>
      <div
        ref={unitWrapperRef}
        style={{ height: "100%", transform: "scale(0.88) translateX(-100px)" }}
      >
        <ImgWrapper>
          {rideItems?.length > 0 && (
            <UnitStepButtons unitStep={unitStep} setUnitStep={setUnitStep} />
          )}

          <ImgContainer>
            <Img
              img={
                unitStep === unitStepDic.unit
                  ? background
                    ? URL.createObjectURL(background)
                    : Background_unit
                  : backgroundRide
                  ? URL.createObjectURL(backgroundRide)
                  : Background_unit_ride
              }
              unitDirection={
                unitDirection[unitStep === unitStepDic.unit ? "unit" : "ride"]
              }
              unitScale={
                unitScale[unitStep === unitStepDic.unit ? "unit" : "ride"]
              }
            />
          </ImgContainer>
        </ImgWrapper>
        <UnitFullWrapper className="animate__animated animate__fadeIn animate__delay-1s">
          {!columns ? null : unitStep === unitStepDic.unit ? (
            <RoomUnit
              itemsCount={itemsCount}
              showDimensions={showDimensions}
              columns={columns}
              colorUnit={colorUnit}
              logoImage={logoImage}
            />
          ) : (
            <RideUnit
              itemsCount={itemsCount}
              showDimensions={showDimensions}
              ride={rideItems}
            />
          )}
        </UnitFullWrapper>
      </div>
      <div
        style={{
          position: "absolute",
          right: "70px",
          top: "70px",
          bottom: "68px",
        }}
      >
        <UnitData
          onSharePress={async () => {
            const res = await getImage();
            // const data = new Blob([res], {type: 'image/png'});
            // const file = new File([data], "univ.png");

            // const csvURL = window.URL.createObjectURL(data)
            // console.log(file);

            let tempLink = document.createElement("a");
            tempLink.href = res;
            tempLink.setAttribute("download", "univ.png");
            tempLink.click();
          }}
          onQuoteClick={onQuoteClick}
          itemsCount={itemsCount}
        />
      </div>
      <ChatWrapper>
        <div style={{ margin: "0 22px" }}>Need help?</div>
        <img width={32} height={32} src={chat} alt={"chat"} />
      </ChatWrapper>

      <div style={{ position: "absolute", left: "70px", top: "70px" }}>
        <UnitTool
          onDimensionsClick={() => setShowDimensions(!showDimensions)}
          onLogoChange={setLogoImage}
          onColorClick={setColorUnit}
          onBackgroundChange={
            unitStep === unitStepDic.unit ? setBackground : setBackgroundRide
          }
          onScaleClick={(size) => {
            let scale =
              unitScale[unitStep === unitStepDic.unit ? "unit" : "ride"];
            switch (size) {
              case "bigger":
                scale += 0.05;
                break;
              case "smaller":
                scale -= 0.05;
                break;
              default:
                break;
            }

            setUnitScale({
              ...unitScale,
              [unitStep === unitStepDic.unit ? "unit" : "ride"]: scale,
            });
          }}
          onMoveClick={(direction) => {
            let x =
              unitDirection[unitStep === unitStepDic.unit ? "unit" : "ride"].x;
            let y =
              unitDirection[unitStep === unitStepDic.unit ? "unit" : "ride"].y;

            switch (direction) {
              case "down":
                y += 3;
                break;
              case "up":
                y -= 3;
                break;
              case "right":
                x += 3;
                break;
              case "left":
                x -= 3;
                break;
              default:
                break;
            }
            setUnitDirection({
              ...unitDirection,
              [unitStep === unitStepDic.unit ? "unit" : "ride"]: { x, y },
            });
          }}
        />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: calc(100vh - 60px);
`;
const ChatWrapper = styled.div`
  position: absolute;
  right: 70px;
  bottom: 0;
  width: 272px;
  background-color: white;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  padding: 10px;
  font-size: 18px;
  color: #4b4b4b;
  font-family: Manrope, serif;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const UnitFullWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(0.9);
`;
const ImgWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  bottom: 20px;
  height: calc(100vh - 58px);
  left: 200px;
  right: 200px;
  z-index: 0;
  margin: auto;
  //border-radius: 10px;
  //border: 1px solid black;
  overflow: hidden;
`;

const ImgContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: 100%;
`;

const Img = styled.div`
  background: #e2e2e0 url(${({ img }) => img}) no-repeat 0 100%;
  transform: scale(${({ unitScale }) => unitScale})
    translate(
      ${({ unitDirection }) => unitDirection.x}px,
      ${({ unitDirection }) => unitDirection.y}px
    );
  background-size: cover;
  height: 100%;
  width: 100%;
  //border-radius: 10px;
`;

export { CreateUnitPage };

const mapStateToProps = ({ ItemsReducer }) => {
  return { items: ItemsReducer.items };
};
